import React from 'react';

function Sources() {
  return (
    <div>
      <h2>Подключённые источники</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 12 }}>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>🏦 СберБизнес</span>
          <span style={{ color: '#10B981', fontSize: 13 }}>● Подключён</span>
        </div>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>🏦 Точка</span>
          <span style={{ color: '#10B981', fontSize: 13 }}>● Подключён</span>
        </div>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>📊 1С:Бухгалтерия</span>
          <span style={{ color: '#F59E0B', fontSize: 13 }}>● Демо</span>
        </div>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>🤖 Khepri AI</span>
          <span style={{ color: '#10B981', fontSize: 13 }}>● Активен</span>
        </div>
      </div>
    </div>
  );
}

export default Sources;